import GrupoEmpresa from "@/modules/GrupoEmpresa/pages/Index";
import GrupoEmpresaAuditoria from "@/modules/GrupoEmpresa/pages/Auditoria";
import GrupoEmpresaConsolidado from "@/modules/GrupoEmpresa/pages/Consolidado";
import GrupoEmpresaPendencias from "@/modules/GrupoEmpresa/pages/Pendencias";

export default [
  {
    name: "grupoEmpresa",
    path: "/grupo-empresarial",
    component: GrupoEmpresa,
    meta: {
      title: "Multiempresas",
      adminOnly: true,
      skipPermissionCheck: true,
      feature: "PLG_MULTIEMPRESA",
      marketplaceVisible: false,
    },
  },
  {
    name: "grupoEmpresaPendencias",
    path: "/grupo-empresarial/pendencias",
    component: GrupoEmpresaPendencias,
    meta: {
      title: "Central de pendências",
      adminOnly: true,
      skipPermissionCheck: true,
      feature: "PLG_MULTIEMPRESA",
      marketplaceVisible: false,
    },
  },
  {
    name: "grupoEmpresaAuditoria",
    path: "/grupo-empresarial/auditoria",
    component: GrupoEmpresaAuditoria,
    meta: {
      title: "Auditoria do grupo",
      adminOnly: true,
      skipPermissionCheck: true,
      feature: "PLG_MULTIEMPRESA",
      marketplaceVisible: false,
    },
  },
  {
    name: "grupoEmpresaConsolidado",
    path: "/grupo-empresarial/painel",
    component: GrupoEmpresaConsolidado,
    meta: {
      title: "Painel consolidado",
      adminOnly: true,
      skipPermissionCheck: true,
      feature: "PLG_MULTIEMPRESA",
      marketplaceVisible: false,
    },
  },
];
